import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { User, Mail, KeyRound, Save } from "lucide-react";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState(user?.email || "");
  const [curr, setCurr] = useState("");
  const [np, setNp] = useState("");
  const [np2, setNp2] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  const [pwdMsg, setPwdMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const saveEmail = async (e) => {
    e.preventDefault();
    setEmailMsg("");
    setBusy(true);
    try {
      const { data } = await api.put("/auth/me", { email });
      setUser(data);
      setEmailMsg("E-posta kaydedildi ✓");
    } catch (e) {
      setEmailMsg(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  const changePwd = async (e) => {
    e.preventDefault();
    setPwdMsg("");
    if (np.length < 6) return setPwdMsg("Yeni şifre en az 6 karakter olmalı");
    if (np !== np2) return setPwdMsg("Yeni şifreler eşleşmiyor");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: curr, new_password: np });
      setPwdMsg("Şifre güncellendi ✓");
      setCurr("");
      setNp("");
      setNp2("");
    } catch (e) {
      setPwdMsg(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-5 flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center border border-[#1a1a1a] bg-[#0a0a0a] rounded-xl text-[#9D4EDD]">
          <User size={18} />
        </div>
        <div>
          <div className="gc-label">HESAP</div>
          <h1 className="font-heading text-2xl md:text-3xl font-black leading-none mt-1">
            Profil <span className="text-[#9D4EDD]">Ayarları</span>
          </h1>
        </div>
      </div>

      <div className="gc-card p-5 mb-4">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <Info label="Kullanıcı adı" value={user?.username} />
          <Info label="Rol" value={user?.role} />
          <Info
            label="Üyelik"
            value={(user?.membership_tier || "free").toUpperCase()}
          />
          <Info
            label="Üyelik bitiş"
            value={user?.membership_expires_at?.slice(0, 10) || "-"}
          />
          <Info label="Toplam sorgu" value={String(user?.total_queries || 0)} />
          <Info label="Bugünkü sorgu" value={String(user?.queries_today || 0)} />
        </div>
      </div>

      <form onSubmit={saveEmail} className="gc-card p-5 mb-4">
        <div className="flex items-center gap-2 mb-3">
          <Mail size={14} className="text-[#9D4EDD]" />
          <div className="font-heading text-base font-bold">E-posta</div>
        </div>
        <label className="gc-label block mb-2">E-posta adresi</label>
        <input
          data-testid="profile-email"
          className="gc-input mb-3"
          type="email"
          placeholder="mail@ornek.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {emailMsg && (
          <div
            className={`text-xs font-mono mb-3 ${
              emailMsg.includes("✓") ? "text-[#00FF66]" : "text-[#9D4EDD]"
            }`}
          >
            {emailMsg}
          </div>
        )}
        <button
          data-testid="profile-email-save"
          className="gc-btn-primary flex items-center gap-1.5"
          disabled={busy}
        >
          <Save size={12} /> KAYDET
        </button>
      </form>

      <form onSubmit={changePwd} className="gc-card p-5">
        <div className="flex items-center gap-2 mb-3">
          <KeyRound size={14} className="text-[#9D4EDD]" />
          <div className="font-heading text-base font-bold">Şifre Değiştir</div>
        </div>
        <label className="gc-label block mb-2">Mevcut şifre</label>
        <input
          data-testid="profile-current-pass"
          className="gc-input mb-3"
          type="password"
          value={curr}
          onChange={(e) => setCurr(e.target.value)}
          required
        />
        <label className="gc-label block mb-2">Yeni şifre</label>
        <input
          data-testid="profile-new-pass"
          className="gc-input mb-3"
          type="password"
          value={np}
          onChange={(e) => setNp(e.target.value)}
          minLength={6}
          required
        />
        <label className="gc-label block mb-2">Yeni şifre (tekrar)</label>
        <input
          data-testid="profile-new-pass2"
          className="gc-input mb-3"
          type="password"
          value={np2}
          onChange={(e) => setNp2(e.target.value)}
          required
        />
        {pwdMsg && (
          <div
            className={`text-xs font-mono mb-3 ${
              pwdMsg.includes("✓") ? "text-[#00FF66]" : "text-[#9D4EDD]"
            }`}
          >
            {pwdMsg}
          </div>
        )}
        <button
          data-testid="profile-pass-save"
          className="gc-btn-primary flex items-center gap-1.5"
          disabled={busy}
        >
          <KeyRound size={12} /> ŞİFREYİ GÜNCELLE
        </button>
      </form>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div>
      <div className="gc-label">{label}</div>
      <div className="text-white font-mono text-sm mt-1">{value}</div>
    </div>
  );
}
